// Client-side session helpers. The API issues a bearer token at login; the role
// drives route guards and navigation. Authorization is still enforced server-side.

export const getToken = () => localStorage.getItem('token');
export const getRole = () => localStorage.getItem('role');
export const isAuthenticated = () => Boolean(getToken() && getRole());

/** Full sign-out: matches the previous behaviour of clearing all portal storage. */
export const clearSession = () => {
  localStorage.clear();
};

/** Session expired (401): drop credentials but keep UI preferences. */
export const expireSession = () => {
  ['token', 'role', 'sub_domain', 'series'].forEach((key) => localStorage.removeItem(key));
};
